export default "__VITE_ASSET__242c965b__"